import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import useGetParamsForRequest from '../../../../shared/hooks/useGetParamsForRequest';
import { getQueryKeys } from '../../../../shared/lib/getQueryKeys';

const errorText = 'Error';

const deleteComment = async (id) => {
  return await request.delete(
    `/Access/transport/note/${id}`,
    null,
    'При удалении комментария произошла ошибка',
    errorText
  );
};

const useDeleteComment = () => {
  const queryClient = useQueryClient();

  const paramsRequestPermits = useGetParamsForRequest();

  return useMutation(deleteComment, {
    onSuccess: (data) => {
      if (data === errorText) return;

      queryClient.refetchQueries(getQueryKeys.permits(paramsRequestPermits));
    },
  });
};

export default useDeleteComment;
